import { cardItems, mediaItems, topicItems, updateItems, indexItems } from '@/mocks/home';

/* ==================== #contact ==================== */
export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[640px] mx-auto bg-background-50 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-send-plane-fill text-2xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            我要爆料 / 联系投稿
          </h2>
          <p className="text-foreground-600 mb-8 leading-relaxed">
            你有独家瓜料线索？发现被遗漏的重磅八卦？欢迎通过下方入口提交爆料内容。
            我们会对投稿人信息严格保密，优质爆料将获得首页重点推荐展示。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              type="button"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
            >
              <i className="ri-edit-line mr-2"></i>
              提交爆料
            </button>
            <button
              type="button"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold border-2 border-secondary-400 text-foreground-700 hover:bg-secondary-50 transition-all cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              商务合作
            </button>
          </div>
          <p className="mt-6 text-xs text-foreground-400">
            投稿内容将在24小时内审核，通过后展示在首页相关区域
          </p>
        </div>
      </div>
    </section>
  );
}

/* ==================== #cards ==================== */
export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
              <i className="ri-flashlight-line"></i>
              热门瓜料
            </div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              最新爆料精选
            </h2>
          </div>
          <a
            href="#updates"
            className="whitespace-nowrap hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer"
          >
            查看全部快讯
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-background-50/90 text-foreground-700 backdrop-blur-sm">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-primary-500 text-background-50">
                      热门
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==================== #media ==================== */
export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            <i className="ri-play-circle-line"></i>
            视频吃瓜
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            热门瓜料视频
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all shadow-sm">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-xs bg-black/70 text-white font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-accent-700 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==================== #topics ==================== */
export function TopicsSection() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-accent-600"></i>;
    if (trend === 'hot') return <i className="ri-fire-line text-primary-500"></i>;
    return <i className="ri-arrow-down-line text-foreground-400"></i>;
  };

  const trendBg = (trend: string) => {
    if (trend === 'up') return 'bg-accent-50 border-accent-200 hover:border-accent-400';
    if (trend === 'hot') return 'bg-primary-50 border-primary-200 hover:border-primary-400';
    return 'bg-background-100 border-background-200 hover:border-background-300';
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            <i className="ri-hashtag"></i>
            实时热度
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            热门话题
          </h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className={`group flex items-center gap-3 px-4 py-3 rounded-xl border cursor-pointer transition-all ${trendBg(item.trend)}`}
            >
              <span className="text-lg">{trendIcon(item.trend)}</span>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors">
                {item.name}
              </span>
              <span className="text-xs text-foreground-500 ml-1">
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==================== #updates ==================== */
export function UpdatesSection() {
  const tagColors: Record<string, string> = {
    '最新': 'bg-primary-100 text-primary-700',
    '热议': 'bg-accent-100 text-accent-700',
    '预告': 'bg-accent-100 text-accent-800',
    '突发': 'bg-primary-500 text-background-50',
    '翻车': 'bg-foreground-100 text-foreground-700',
    '爆料': 'bg-primary-50 text-primary-600',
    '维权': 'bg-accent-50 text-accent-600',
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            <i className="ri-time-line"></i>
            实时快讯
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            瓜料快讯
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto">
          {updateItems.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-start gap-4 py-4 ${
                idx < updateItems.length - 1 ? 'border-b border-background-200' : ''
              }`}
            >
              <span className="shrink-0 text-xs text-foreground-400 w-16 pt-0.5">
                {item.time}
              </span>
              <span
                className={`shrink-0 px-2 py-0.5 rounded text-xs font-semibold ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}
              >
                {item.tag}
              </span>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed hover:text-primary-500 transition-colors cursor-pointer">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==================== #index ==================== */
export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            <i className="ri-folder-line"></i>
            分类浏览
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            吃瓜专题索引
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-4 p-5 rounded-xl border border-background-200 bg-background-50 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 shrink-0 rounded-lg bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-primary-500 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}